<template>
  <!-- START HOMEPAGE DESIGN AREA -->
  <header id="home" class="welcome-area">
    <div class="header-top-area" :class="{ 'menu-bg': menuBg }">
      <div class="container">
        <div class="row">
          <div class="header-top">
            <div class="col-md-9 col-sm-8">
              <div class="tour-info">
                <ul>
                  <li><i class="fa fa-phone"></i>(0 81 45) 12 68</li>
                  <li><i class="fa fa-envelope"></i><a href="mailto:info@reisebuero-burkhard.de" class="tour-info-email"><span class="text-lowercase">info@reisebuero-burkhard.de</span></a></li>
                  <li><i class="fa fa-instagram"></i><a href="https://www.instagram.com/reisebuero_burkhard_" target="_blank" class="tour-info-email"><span class="text-lowercase">reisebuero_burkhard_</span></a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <!-- START LOGO DESIGN AREA -->
            <div class="logo">
              <router-link :to="{ name: 'Home' }" class="inline">
                <p>{{ globalVars.appName }}</p>
              </router-link>
            </div>
            <!-- END LOGO DESIGN AREA -->
          </div>
          <div class="col-md-9">
            <!-- START MENU DESIGN AREA -->
            <div class="mainmenu">
              <div class="navbar navbar-nobg">
                <div class="navbar-header">
                  <button type="button" class="navbar-toggle" @click="toggleMenu">
                    <span class="sr-only">Toggle navigation</span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                  </button>
                </div>
                <div class="navbar-collapse" :class="{ collapse: !menuOpen, in: menuOpen }">
                  <ul class="nav navbar-nav navbar-right">
                    <li v-for="item in navigationHeader" :key="item.key" class="active">
                      <router-link :to="{ name: item.href }" class="smoth-scroll" @click="closeMenu">{{ item.name }}</router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <!-- END MENU DESIGN AREA -->
          </div>
        </div>
      </div>
    </div>
    <div class="welcome-image-area version" style="background: url(/assets/images/Thailand-Beaches-and-Scenery.webp); background-size: cover; background-attachment: fixed;">
      <div class="display-table">
        <div class="display-table-cell">
          <div class="container">
            <div class="row">
              <div class="col-md-12">
                <div class="header-text text-center">
                  <h1>{{ pageTitle }}</h1>
                  <!-- <p>Travel to the any corner of the world, without going around in circles connect with us.</p> -->
                  <p>&nbsp;</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
  <!-- / END HOMEPAGE DESIGN AREA -->  
</template>



<script>
// import Header from '@/components/Header.vue'
import { ref, inject, onMounted, onUnmounted } from 'vue'
import { useStore } from 'vuex'

export default {
  name: 'Header',
  setup() {

    const globalVars = inject('globalVars')
    const store = useStore()

    const pageTitle = ref('')
    const menuOpen = ref(false)

    store.watch((_state, _getters) => store.getters['pageTitle/title'], () => {
      pageTitle.value = store.getters['pageTitle/title']
    })

    const navigationHeader = [
      { name: 'Urlaubsreisen', key: 'ur', href: `Urlaubsreisen` },
      { name: 'Studienreisen', key: 'sr', href: `Studienreisen` },
      { name: 'Specials', key: 'specials', href: `Specials` },
      { name: 'Über Uns', key: 'uu', href: `UeberUns` },
    ]

    const menuBg = ref(false)
    let ticking = false

    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          menuBg.value = window.scrollY > 200
          ticking = false
        })
        ticking = true
      }
    }

    onMounted(() => {
      window.addEventListener('scroll', onScroll, { passive: true })
      menuBg.value = window.scrollY > 200
    })

    onUnmounted(() => {
      window.removeEventListener('scroll', onScroll)
    })

    const toggleMenu = () => {
      menuOpen.value = !menuOpen.value
    }

    const closeMenu = () => {
      menuOpen.value = false
    }

    return {
      globalVars,
      navigationHeader,
      pageTitle,
      menuBg,
      menuOpen,
      toggleMenu,
      closeMenu,
    }

  }
}

</script>